/** 公开的申请人注册页面（计划 F3），与 1A 的地图登记横幅键一起并入 `planning.register`。 */
export default {
  // The case page's map-register banner (1A) shares this root.
  pending: '地图更新待处理。',
  dead: '地图更新失败。',
  lastError: '最近错误：{{error}}',
  retry: '重试地图更新',
  retried: '地图更新已重新排队。',
  // Plan P4-1a D-411: "may", because the public form cannot read whether the tenant turned notifications on.
  emailNotice: '议会可能会通过电子邮件向您发送有关申请的最新消息。登录后，您可以在“电子邮件偏好”中将其关闭。',
  shell: {
    language: '语言',
    fallbackName: '规划许可',
  },
  form: {
    title: '注册为申请人',
    intro: '顾问可在线提交规划许可申请。请提交您的资料：官员审核后，批准时您将通过电子邮件收到登录信息。',
    email: '电子邮件',
    displayName: '全名',
    firm: '公司（选填）',
    regNo: '专业注册编号（选填）',
    submit: '提交注册',
    required: '必填。',
    emailInvalid: '请输入有效的电子邮件地址。',
    tooLong: '过长：最多 {{max}} 个字符。',
    haveCode: '已经注册？查看申请状态',
    signIn: '已有账户？登录',
  },
  accepted: {
    title: '已收到注册',
    body: '如果您的资料可以受理，官员将审核您的申请。批准后，您将通过电子邮件收到登录信息。',
    codeLabel: '您的状态码',
    codeHint: '请保存此状态码：这是查询注册状态的唯一方式，离开此页面后将不再显示。',
    copy: '复制状态码',
    copied: '已复制',
  },
  status: {
    title: '注册状态',
    intro: '请粘贴注册时获得的状态码。',
    codeLabel: '状态码',
    check: '查询状态',
    submittedAt: '申请于 {{date}}',
    reason: '理由：{{reason}}',
    states: {
      submitted: '等待审核',
      approved: '已批准。请查看电子邮件中的登录信息。',
      rejected: '未获批准',
      superseded: '已被使用相同邮箱的较新注册取代',
      expired: '未作决定即已过期。您可以重新注册。',
    },
    notFound: '没有与此状态码匹配的注册。请确认已完整粘贴。',
    registerAgain: '重新注册',
  },
  errors: {
    closed: '此组织未开放申请人注册。',
    rateLimited: '您的网络尝试次数过多。请等待几分钟后重试。',
    invalid: '部分资料无效。请检查标出的字段。',
    network: '无法连接服务器。请检查网络后重试。',
    generic: '出现问题，请重试。',
  },
} as const
